import { jsx as _jsx } from "react/jsx-runtime";
import { getFieldTitle } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { RichTextInput } from "../../RichTextInput";
/** A body of text a broker may format, stored as HTML (DEV-3323). */
export var RichTextField = function (props) {
    var formData = props.formData, onChange = props.onChange, uiSchema = props.uiSchema, _a = props.rawErrors, rawErrors = _a === void 0 ? [] : _a, _b = props.formContext, formContext = _b === void 0 ? {} : _b;
    var title = getFieldTitle(uiSchema, formContext);
    var optional = uiSchema.optional, placeholder = uiSchema.placeholder;
    // The Editor renders its own Labelled, so wrapping it in a second one
    // printed the label and the error twice.
    return (_jsx(RichTextInput, { value: formData || "", onChange: onChange, placeholder: placeholder, label: title, error: rawErrors[0], optional: optional }));
};
